import { Container, Row } from 'reactstrap'
import BreadCrumb from 'Components/Common/BreadCrumb'
import { useState } from 'react'
import DeleteModal from 'Components/Common/DeleteModal'
import { TruckingRQ } from 'Hooks/Queries'
import withTable from 'Components/Common/Table/withTable'
import { TruckingItem } from 'Components/Master/TruckingItem'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { DATA_LIMIT } from 'configs'

export default function ListTrucking() {
  const [deleteTruckingId, setDeleteTruckingId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(DATA_LIMIT);
  const [keyword, setKeyword] = useState(null);
  const {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch
  } = TruckingRQ.useGetDataList()(false, keyword, offset, limit);

  const useQuery = useQueryClient();
  const navigate = useNavigate();

  const onDeleteSuccess = (key) =>{
    setDeleteModal(false);
    setDeleteTruckingId(null)
    useQuery.invalidateQueries({queryKey:[key]})
    refetch()
  }
  const { mutate: deleteTruck } = TruckingRQ.useDeleteData(onDeleteSuccess)();

  const onDeleteClick = (id) => {
    setDeleteModal(true);
    setDeleteTruckingId(id)
  }

  const onDeleteConfirm = () => {
    deleteTruck(deleteTruckingId);
  }

  const onAddButtonClicked = () => {
    navigate('/app/truckings/create')
  }

  const onPageChange = (i) => {
    setOffset(i.selected);
  }

  const onPerPageChange = (i) => {
    setLimit(i);
    setOffset(0);
  }

  const onKeywordChange = (value) => {
    setKeyword(value)
  }

  const TruckingTable = withTable(
    TruckingItem,
    'truckings',
    ['NO', 'Action', 'Nama', 'PIC Name', 'PIC Email', 'Address', 'STATUS'],
    onDeleteClick,
    onAddButtonClicked
  );

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Truckings"/>

        <Row>
          <TruckingTable
            data={data}
            isFetching={isFetching}
            isFetchingNextPage={isFetchingNextPage}
            hasNextPage={hasNextPage}
            loading={isFetching}
            error={error}
            status={status}
            fetchNextPage={fetchNextPage}
            onPageChange={onPageChange}
            onPerPageChange={onPerPageChange}
            onKeywordChange={onKeywordChange}
            keyword={keyword}
          />
        </Row>
      </Container>
      <DeleteModal
        onDeleteConfirm={() => onDeleteConfirm()}
        onCloseClick={() => setDeleteModal(v => !v)}
        show={deleteModal}
        loading={false}
      />
    </div>
  )
}
